import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem,  } from '@mui/material';


const TableFilter = ({ onFilterChange }) => {
  const [selectedClass, setSelectedClass] = useState('6th');
  const [selectedSubject, setSelectedSubject] = useState('Maths');

  const classOptions = ['5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th'];
  const subjectOptions = {
    '5th': ['Maths', 'Science', 'English'],
    '6th': ['Maths', 'Science', 'English'],
    '7th': ['Maths', 'Science', 'English'],
    '8th': ['Maths', 'Science', 'English'],
    '9th': ['Maths', 'Science', 'English'],
    '10th': ['Maths', 'Science', 'English'],
    '11th': ['Maths', 'Physics', 'Chemistry'],
    '12th': ['Maths', 'Physics', 'Chemistry'],
  };

  const handleClassChange = (event) => {
    const selectedClass = event.target.value;
    setSelectedClass(selectedClass);
    setSelectedSubject(subjectOptions[selectedClass][0]);
    onFilterChange(selectedClass, subjectOptions[selectedClass][0]);
  };

  const handleSubjectChange = (event) => {
    const selectedSubject = event.target.value;
    setSelectedSubject(selectedSubject);
    onFilterChange(selectedClass, selectedSubject);
  };

  return (
    <div className='mb-2'>
      <FormControl className='mx-2'>
        <InputLabel htmlFor="class-select">Class</InputLabel>
        <Select
          value={selectedClass}
          onChange={handleClassChange}
          label="Class"
          inputProps={{
            name: 'class',
            id: 'class-select',
          }}
        >
          {classOptions.map((cls) => (
            <MenuItem key={cls} value={cls}>
              {cls}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className='mx-2' >
        <InputLabel htmlFor="subject-select">Subject</InputLabel>
        <Select
          value={selectedSubject}
          onChange={handleSubjectChange}
          label="Subject"
          inputProps={{
            name: 'subject',
            id: 'subject-select',
          }}
        >
          {subjectOptions[selectedClass].map((subject) => (
            <MenuItem key={subject} value={subject}>
              {subject}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TableFilter;
